// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bv12x7{padding-left:var(--ds-space-075,6px)}\n._ca0q12x7{padding-top:var(--ds-space-075,6px)}\n._n3td12x7{padding-bottom:var(--ds-space-075,6px)}\n._u5f312x7{padding-right:var(--ds-space-075,6px)}", ""]);
// Exports
module.exports = exports;
